
export const shiftWorkEN = {
    categoryConfig : {
        filter : {
            all : "All",
            pending : "Pending",
            approved : "Approved",
        }
    },
    "shiftWorkSider": {
    "headingLabel": "Work shift settings",
        "information": "General information",
        "midShiftSettings": "Mid Shift Settings",
        "workSchedules": "Work schedules",
        "workScheduleAdd": "Add work schedule",
        "workScheduleUpdate": "Update work schedule",
        "noTime" : "Indefinite"
},
    "shiftWorkTitle": {
    "title": "Title",
        "assignmentType": "Types of work schedule",
        "weekly" : "Weekly",
        "fixed_date" : "Fixed date",
        "period" : "Period",
        "date_range" : "Date range",
        "startDate": "Start date",
        "endDate": "End date",
        "createDate": "Create date",
        "status": "Status",
        "assign_department_position" : "Assign department position",
        "assign_personnel" : "Assign personnel"

},
    "shiftWorkMenu": {
    "addShiftWork": "Add work schedule",
        "editShiftWork" : "Edit work schedule",
        "deleteShiftWork" : "Delete work schedule",
        "approvalShiftWork" : "Approved",
        "unApprovalShiftWork" : "Undo approval"
}	,
    "shiftWorkForm": {
        "week" : "Days of the week",
        "shift" : "Shift",
        "title": "Title shiftWork",
        "titleEnter": "Enter title shiftWork",
        "titleEnterMessage": "Title field is required",

        "nameTypeShiftWork": "Shift type",
        "nameTypeShiftWorkMessage": "Shift type is a required field!",
        "nameTypeShiftWorkEnter": "Select a shift type",

        "assignmentType" : "Types of shift assignment",
        "assignmentTypeMessage" : "Types of shift assignment is required",
        "assignmentTypeEnter" : "Select types of shift assignment ",

        "typeShift" : "Types of shift",
        "typeShiftMessage" : "Types of shift field is required",
        "typeShiftEnter" : "Select types of shift ",

        "departments" : "Department",
        "departmentsEnter" : "Select all department",

        "positions" : "Job position",
        "positionsEnter" : "Select all position",

        "assignmentId" : "Assign by",
        "assignmentIdMessage" : "Assign by is required",
        "assignmentIdEnter" : "Select assign by ",


        "startDate" : "Start date",
        "endDate" : "End date" ,

        "assignmentDetails" : "Assignment details" ,
        "generalInformation" : "General information" ,
        "assignmentRepeatMessage" : "This assignment will repeat" ,
        "day" : "Date" ,
        "dayOfWeek" : "Day of week" ,

        "repeatNumber" : "Enter the number of iterations",
        "repeatNumberEnter" : "Once every",

        "employeeId" : "Employee id",
        "assignmentTypeEmp" : "Employee name",

        "employeeSearchEnter" : "Select employee ",
        "employeeSearchMessage" : "Please select employee",


        "shifts" : "Select shifts" ,

        "nameEmployee" : "Employee name",

        "approvalId" : "Approval name",
        "approvalIdMessage" : "Please select approval name",
        "approvalIdEnter" : "Search approval name",


},

    "assignBy": {
        "repeatWeek": "Repeat by week",
        "byFixDate": "By fixed date",
        "dayCycle": "Repeat by cycle",
        "rangeDate": "Repeat by date range"
    },
    "shiftData" : {
    "weekOff" : "Week off",
        "cancelOff" : "Cancel off",
        "autoTakeShift" : "Auto take shift"
}	,

    "assignByRepeatWeekly" : {
    "monday" : "Monday",
        "tuesday" : "Tuesday",
        "wednesday" : "Wednesday",
        "thursday" : "Thursday",
        "friday" : "Friday",
        "saturdayOdd" : "Saturday odd",
        "saturdayEven" : "Saturday even",
        "sunday" : "Sunday"

},

    "messageShiftWork" : {
    "startDateEqual" : "The end date must be greater than the start date",
        "chooseStartDate" : "Choose start date",
        "confirmDelete" : "Confirm delete shift work !",
        "delete" : "Delete shift work success!",
        "approval" : " Approval shift work success!",
        "unApproval" : " Undo approval shift work success!",
        "confirmApproval" : " Confirm approval shift work!",
        "confirmUnApproval" : " Confirm undo approval shift work!",
        "approved" : "Approved",
        "pending" : "Pending"
},
    "create_quick_shift_work" : "Create shift quickly"
}
